export const config = {
	XhrHttpModule: {
		origin: "",
		timeout: 30000,
		compress: false
	},
	// gen-2 apiv2 (Cloud Run) direct URL — used ONLY by the TTS SSE stream to
	// bypass Firebase Hosting, which buffers rewrite responses and breaks SSE.
	// Empty/absent falls back to XhrHttpModule.origin (local proxy).
	ttsStreamOrigin: "https://us-central1-ir-q-support-dev.cloudfunctions.net/apiv2",
	ThunderstormModule: {
		appName: 'IR Support Portal - DEV'
	},
	UnitsModule: {
		dbName: "elliq-env-dev"
	},
	"labTestUrl": "https://ir-q-support-dev-new.firebaseapp.com/name-input",
	"suggestTranslationEnabled": true,
	ActivationModule: {
		userOnlyEnabled: true
	},
	EnvironmentModule: {
		envName: "dev",
		// Declared so every env's config.ts has the field index.tsx reads (the build type-checks it).
		offline: false,
		kasperoFeUrl: "https://ir-q-kaspero-dev.firebaseapp.com",
        kasperoBeUrl: "https://us-central1-ir-q-kaspero-dev.cloudfunctions.net/apiv2",
		apiServerUrl: "https://elliq-api-server-dev.s.elliq.co:443/api/"
	},
	ExampleModule: {
		remoteUrl: "/v1/sample/endpoint-example"
	},
	PackageManagerModule: {
		pmOrigin: "/pm-api"
	},
	ContactsModule: {
		websiteUrl: "https://ir-q-messaging-dev.firebaseapp.com",
		defaultAreaCode: "+972"
	},
	CareCenterModule: {
		websiteUrl: "https://ir-q-care-center-dev.firebaseapp.com",
		commandsUrl: "https://ir-commands-dev.web.app"
	},
	KasperModule: {
		origin: "https://us-central1-ir-q-kaspero-dev.cloudfunctions.net/apiv2"
	},
	PushPubSubModule: {
		publicKeyBase64: 'BLJlRcHETwkn0axdcfEoEVH08QDFYYuY-loLwVWA8BDbLZcSL2wg80MULvce2QLbFJxJk048N0eulO3y0-BBpJw',
		swFileName: 'sw.js'
	},
	FirebaseModule: {
		local: {
			apiKey: "AIzaSyCeGOack6XgSyb-xHyxUuFSS5AI4ovLhhQ",
			authDomain: "ir-q-support-dev.firebaseapp.com",
			databaseURL: "https://ir-q-support-dev.firebaseio.com",
			projectId: "ir-q-support-dev",
			storageBucket: "ir-q-support-dev.appspot.com",
			messagingSenderId: "731367534",
			appId: "1:731367534:web:bfb26c2cd51bab8f6d3e7f"
		},
		ks: {
			apiKey: "AIzaSyDZHdnc1mUdQTA4FjKrvmlszHfBy0JK6hk",
			authDomain: "elliq-env-map.firebaseapp.com",
			databaseURL: "https://elliq-env-map.firebaseio.com",
			projectId: "elliq-env-map",
			storageBucket: "elliq-env-map.appspot.com",
			messagingSenderId: "1067544170250",
			appId: "1:1067544170250:web:2acdc4358c16ee9b4034f3"
		},
		pushResult: {
			id: "ir-q-kaspero-dev",
			apiKey: "AIzaSyAR3ezjPyOotbwcYxEkSWXkGdyoxD3M_6E",
			authDomain: "ir-q-kaspero-dev.firebaseapp.com",
			databaseURL: "https://ir-q-kaspero-dev-default-rtdb.firebaseio.com",
			projectId: "ir-q-kaspero-dev",
			storageBucket: "ir-q-kaspero-dev.appspot.com",
			messagingSenderId: "49437068742",
			appId: "1:49437068742:web:c3b069791cc97a77dc36c7",
			measurementId: "G-KT4LCK1R5G"
		},
		sd: {
			apiKey: "AIzaSyA7YqQxjZO8M_ayGUwkY3YrJPH4gU9jg5w",
			authDomain: "ir-q-state-dashboard-staging.firebaseapp.com",
			databaseURL: "https://ir-q-state-dashboard-staging-773a7.firebaseio.com",
			projectId: "ir-q-state-dashboard-staging",
			storageBucket: "ir-q-state-dashboard-staging.appspot.com",
			messagingSenderId: "868100673306",
			appId: "1:868100673306:web:0a82b76ed1eed42bcde6a3"
		}
	},
	installBlockerConditions: [
		{
			currentVersionLowerThan: "3.4.3",
			packageVersionIsEqualOrBiggerThan: "3.4.3",
			mustInstallFirst: "3.4.3"
		}
	],
	BigQueryModule: {
		dataSet: "ir-datastore-test"
	}
};
